import { render } from "./StrategyHome.vue?vue&type=template&id=2b111b55&scoped=true"
import script from "./StrategyHome.vue?vue&type=script&lang=js"
export * from "./StrategyHome.vue?vue&type=script&lang=js"

import "./StrategyHome.vue?vue&type=style&index=0&id=2b111b55&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b111b55"]])

export default __exports__